import { useState } from "react";
import { ShoppingBag, X, ExternalLink } from "lucide-react";

const NAVY = "#0A2A5A";
const GOLD = "#F9AB0D";
const LAUNCH_DATE = "2026-09-28";
const DISMISS_KEY = "merch_launch_banner_dismissed";

export const MerchLaunchBanner = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  const isLive = new Date().toISOString().slice(0, 10) >= LAUNCH_DATE;
  if (!isLive || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="merch-launch-banner"
      className="flex items-center gap-3 px-4 py-3 sm:px-6"
      style={{ backgroundColor: NAVY, borderBottom: `2px solid ${GOLD}` }}
    >
      <div
        className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: GOLD }}
      >
        <ShoppingBag size={18} style={{ color: NAVY }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-bold leading-tight">
          The RecoveryMatch Merch Store is officially OPEN!
        </p>
        <p className="text-xs hidden sm:block" style={{ color: "rgba(255,255,255,0.65)" }}>
          Wear your recovery proudly — tees, hoodies & more at shop.recoverymatch.com
        </p>
      </div>
      <a
        href="https://shop.recoverymatch.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-extrabold whitespace-nowrap transition-transform hover:scale-105"
        style={{ backgroundColor: GOLD, color: NAVY }}
        data-testid="merch-banner-shop-btn"
      >
        Shop Now <ExternalLink size={12} />
      </a>
      <button
        onClick={dismiss}
        className="p-1.5 rounded-full transition-colors hover:bg-white/10 flex-shrink-0"
        style={{ color: "rgba(255,255,255,0.5)" }}
        aria-label="Dismiss"
        data-testid="merch-banner-dismiss-btn"
      >
        <X size={16} />
      </button>
    </div>
  );
};
